import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Observable, Subscription } from 'rxjs'
import { UsuarioLogin } from 'src/app/models/usuario-login'
import { UserLoginService } from 'src/app/services/usuario-login.service'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  private userSubscription!: Subscription
  userLogin?: UsuarioLogin | null
  perfil: string = ''

  constructor(private userLoginService: UserLoginService, private router: Router) {}

  ngOnInit(): void {
    this.userSubscription = this.userLoginService.user$.subscribe(user => {
      this.userLogin = user
      this.getPerfilAndRedirectDiscente()
    })
  }

  private getPerfilAndRedirectDiscente(): void {
    let redirect = false
    if (this.userLogin) {
      this.userLogin.roles.forEach(role => {
        if (role !== '**' && role !== '!!') {
          this.perfil += role + ', '
        }
        if (role === 'DISCENTE') {
          redirect = true
        }
      })
      if (this.perfil.length > 0) {
        this.perfil = this.perfil.slice(0, -2)
      }
      if (redirect) {
        this.router.navigate([`discente/status-inscricao`])
      }
    }
  }

  get userLogin$(): Observable<UsuarioLogin | null> {
    return this.userLoginService.user$
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe()
    }
  }
}
